.noStyleLink {
  /* no underline */
  text-decoration: none;
  /* don't change the color of visited links */
  color: inherit;
}
